import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function ToggleButton(theme: Theme) {
  const isLight = theme.palette.mode === 'light';

  return {
    MuiToggleButton: {
      styleOverrides: {
        root: {
          color: theme.palette.grey[500],
          border: `solid 1px ${theme.palette.grey[500_32]}`,
          '&.Mui-selected': {
            color: theme.palette.grey[isLight ? 50 : 600],
            backgroundColor: theme.palette.primary.main,
          },
          '&.Mui-selected:hover': {
            backgroundColor: theme.palette.primary.main,
          },
          '&.Mui-disabled': {
            color: theme.palette.grey[500_48],
          },
        },
      },
    },
  };
}
